const LogoutIcon = () => {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M3 36C2.2 36 1.5 35.7 0.9 35.1C0.3 34.5 0 33.8 0 33V3C0 2.2 0.3 1.5 0.9 0.9C1.5 0.3 2.2 0 3 0H17.55V3H3V33H17.55V36H3ZM27.3 26.75L25.15 24.6L30.25 19.5H12.75V16.5H30.15L25.05 11.4L27.2 9.25L36 18.05L27.3 26.75Z"
                fill="#64648C"
            />
        </svg>
    )
}

export default LogoutIcon